// extracted by mini-css-extract-plugin
export default {"disclaimer":"Disclaimer_disclaimer__UlX0s","btn":"Disclaimer_btn__9iyg4"};